import React from 'react'
import './Home.scss'

import STYLE from '../../base'
import TPLogo from '../../components/TPLogo/TPLogo'

const Home = () => (
  <article className="home">
    <header className="header">
      <TPLogo primaryColor={STYLE.colors.primary} secondaryColor={STYLE.colors.secondary}/>
      <h1>Welcome to <i>Bank Statements</i>.</h1>
    </header>
    <main className="main">
      <p className="warning">No borrower information has been provided for the bank statements.</p>
      <p>Please contact your Lending Partner for more information.</p>
      <a className="link" href="https://www.truepillars.com" rel="noopener noreferrer">Home</a>
    </main>
  </article>
)

export default Home
